import React from 'react';

import {
  NumberInput,
  PasswordInput,
  TextField,
  TextInput,
  Validator,
  NumberField,
  DateField,
  BooleanField,
  BooleanInput,
} from 'react-admin';

import ColorPicker, { ColorField } from '../components/layout/ColorPicker';
import SmartDateInput from './SmartDateInput';
import SmartDateTimeInput from './SmartDateTimeInput';
import dateParse, { dateFormat } from '../components/utils/dateParser';
import EditFieldLayout from '../components/layout/EditFieldLayout';

const typeFields = {
  text: TextField,
  textarea: TextField,
  number: NumberField,
  password: TextField,
  date: DateField,
  dateTime: DateField,
  color: ColorField,
  boolean: BooleanField,
} as const;

const typeInputs = {
  text: TextInput,
  textarea: TextInput,
  number: NumberInput,
  password: PasswordInput,
  date: SmartDateInput,
  dateTime: SmartDateTimeInput,
  color: ColorPicker,
  boolean: BooleanInput,
} as const;

const EditField = ({
  source,
  label,
  showEdit,
  validate,
  type = 'text',
  dateOptions,
  fieldComponent,
  showTime = false,
}: {
  source: string;
  label: string;
  showEdit: boolean;
  validate?: Validator | Validator[];
  type?: keyof typeof typeFields;
  dateOptions?: Intl.DateTimeFormatOptions;
  fieldComponent?: (props: any) => React.JSX.Element | null;
  showTime?: boolean;
}) => {
  const FieldComponent = fieldComponent || typeFields[type];
  const InputComponent = typeInputs[type];
  return (
    <EditFieldLayout
      source={source}
      label={label}
      showEdit={showEdit}
      inputElement={(
        <InputComponent
          label={false}
          source={source}
          validate={validate}
          parse={type === 'dateTime' ? dateParse : undefined}
          format={type === 'dateTime' ? dateFormat : undefined}
          multiline={type === 'textarea'}
          helperText={false}
        />
      )}
      fieldElement={(
        <FieldComponent
          source={source}
          emptyText="-"
          options={type === 'date' || type === 'dateTime' ? dateOptions : {}}
          showTime={showTime}
        />
      )}
    />
  );
};

export default EditField;
